
import Diagram from "./Assets/Diagram.svg";
import Dollargram from "./Assets/Dollargram.svg";
import Towergram from "./Assets/Towergram.svg";
import KeySteps from "./Assets/KeySteps.svg";
const App = () => {
    return (
        <div className="font-custom flex flex-col items-center">
            {/* Section 1: Main Title */}
            <section className="w-full lg:w-3/4 px-4 py-4 text-center">
                <p className="xl:text-8xl lg:text-8xl md:text-8xl sm:text-8xl text-6xl text-black">
                    <span className="textGreen">Overfunded Fund</span>
                    <span> is a </span>
                    <span className="curveLineText">half</span>
                    <span> of all money of the world</span>
                </p>
            </section>

            {/* Section 2: Icons */}
            <section className="w-full grid grid-cols-5 justify-items-center items-center py-8 gap-4">
                <div className="justify-self-center col-start-2 col-end-2">
                    <img src={Diagram} alt="Diagram" className="xl:w-48 h-auto" />
                </div>
                <div className="justify-self-center">
                    <img src={Dollargram} alt="Dollargram" className="xl:w-48 h-auto" />
                </div>
                <div className="justify-self-center">
                    <img src={Towergram} alt="Towergram" className="xl:w-80 h-auto lg:w-fit" />
                </div>
            </section>

            {/* Section 3: Strategy Title */}
            <section className="w-full px-4 py-8 text-center">
                <p className="xl:text-8xl lg:text-8xl md:text-8xl sm:text-8xl text-6xl textGreen">
                    <span className="textGreen">Overfunded Fund's HYPE Domination Strategy</span>
                </p>
            </section>

            {/* Section 4: Key Steps */}

            <div className="grid xl:grid-cols-6  items-center justify-center ">

                <section className="xl:col-span-5 xl:col-start-2 xl:col-end-6 md:col-span-6 m-10">
                    <img src={KeySteps} alt="About us" className="w-full h-full object-cover" />
                </section>

            </div>

        </div>
    );
};

export default App;